var map = {
	"./kidi.png": 1959,
	"./kido.png": 2092,
	"./kidtre.png": 2256,
	"./kish.png": 7849,
	"./nou.png": 7809,
	"./pisk.png": 9630,
	"./shir.png": 1545,
	"./shoki.png": 6890,
	"./skir.png": 7972,
	"./skirt.png": 1170,
	"./snk.png": 1290,
	"./three.png": 7048
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1368;